import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import LoaderForm from "./LoaderForm";
import { TailSpin } from "react-loader-spinner";
import Loader from "./Loader";
import "../styles/AddEmployee.css";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import emailIcon from "../images/emailIcon.svg";
import nameIcon from "../images/nameIcon.svg";
import employeeIdIcon from "../images/employeeIdIcon.svg";
import payrateIcon from "../images/payrateIcon.svg";
import { useAuth } from "../auth/auth";
import Select from "react-select";
import { PERMISSIONS } from "../utils/rbac";
import { useRoutePermissionGuard } from "../hooks/usePermissionGuard";
const apiUrl = process.env.REACT_APP_API_URL;

function EditEmployee() {
  const { allowed: canEditEmployee, PermissionDialog } = useRoutePermissionGuard(
    PERMISSIONS.EDIT,
    "edit employee",
  );
  const location = useLocation();
  const id = location.state;
  const paymentOptions = [
    { value: "Cheque", label: "Cheque" },
    { value: "Direct Deposit", label: "Direct Deposit" },
    { value: "CashApp", label: "CashApp" },
    { value: "Weekly Bank Transfer", label: "Weekly Bank Transfer" },
  ];
  const [employeeData, setEmployeeData] = useState(null);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useAuth();

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const shouldApplyFilledClass = (value) => {
    return value !== undefined && value !== null && value !== "";
  };

  useEffect(() => {
    fetchEmployeeDetails(id);
  }, [id]);

  const fetchEmployeeDetails = async (id) => {
    try {
      const response = await axios.post(`${apiUrl}/getEmployeeDetail`, {
        id: id,
      });
      if (response.data && response.data.data) {
        setEmployeeData(response.data.data);
        setImageUrl(response.data.data.image);
      }
    } catch (error) {
      //console.error("Error:", error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id:
        employeeData?.id != null && employeeData?.id !== ""
          ? employeeData.id
          : (id ?? ""),
      name: employeeData?.name || "",
      email: employeeData?.email || "",
      image: employeeData?.image ?? "",
      payRate: employeeData?.payRate || "",
      secondaryPayRate:
        employeeData?.secondaryPayRate !== undefined &&
        employeeData?.secondaryPayRate !== null
          ? employeeData.secondaryPayRate
          : "",
      tertiaryPayRate:
        employeeData?.tertiaryPayRate !== undefined &&
        employeeData?.tertiaryPayRate !== null
          ? employeeData.tertiaryPayRate
          : "",
      selectedPaymentMethod: employeeData?.payment_method || "",
      isPayslipEligible:
        employeeData?.isPayslipEligible !== undefined &&
        employeeData?.isPayslipEligible !== null
          ? Number(employeeData.isPayslipEligible) === 1
          : true,
      isInvoiceEligible:
        employeeData?.isInvoiceEligible !== undefined &&
        employeeData?.isInvoiceEligible !== null
          ? Number(employeeData.isInvoiceEligible) === 1
          : true,
      //image: '',
    },
    onSubmit: async (values) => {
      if (!values.name.trim()) {
        showMessage("Please enter employee Name");
        return;
      }

      // if (!values.email) {
      //   showMessage("Please enter employee email");
      //   return;
      // }
      if (!values.payRate) {
        showMessage("Please enter employee Pay Rate");
        return;
      }

      if (!values.selectedPaymentMethod) {
        showMessage("Please select payment method");
        return;
      }

      const payRateNum = Number(values.payRate);
      const idNum = Number(values.id);
      if (!Number.isFinite(payRateNum) || !Number.isFinite(idNum)) {
        showMessage("Pay rate and ID must be numbers");
        return;
      }
      // if (!values.secondaryPayRate) {
      //   showMessage("Please enter employee Secondary Pay Rate");
      //   return;
      // }

      // if (isNaN(values.secondaryPayRate)) {
      //   showMessage("Secondary Pay rate must be numbers");
      //   return;
      // }
      setLoading(true);
      try {
        let imageUrl = values.image; // Retrieve the existing image URL from the form values

        if (image) {
          const timestamp = Date.now(); // Generate a unique timestamp
          const imageName = `${timestamp}_${image.name}`; // Concatenate timestamp with image name

          const storageRef = firebase.storage().ref().child("employees");
          const imageRef = storageRef.child(imageName);
          await imageRef.put(image);
          imageUrl = await imageRef.getDownloadURL();
          //console.log("imageUrl", imageUrl);
          values.image = imageUrl; // Update form values with the new image URL
        }
        console.log(values);
        const valuesToSend = {
          ...values,
          payment_method: values.selectedPaymentMethod, // ✅ Add this
        };
        const response = await axios.post(
          `${apiUrl}/editEmployee`,
          valuesToSend,
        );
        if (response.data && response.data.status === 1) {
          // Show success message
          //window.alert(response.data.message);
          showMessage(response.data.message);
        } else {
          // Show error message
          //window.alert("Error: " + response.data.message);
          showMessage("Error: " + response.data.message);
        }
      } catch (error) {
        //console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0])); // Display the selected image instantly

      // Set the data-name attribute to display the file name
      e.target.setAttribute("data-name", e.target.files[0].name);
    }
  };

  // if (employeeData === null) {
  //   return <Loader />;
  // }

  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <PermissionDialog />
      <div
        className={`container-addEmployee ${!canEditEmployee ? "pointer-events-none opacity-60" : ""}`}
      >
        <div className="admin-header">
          <div className="left-section">
            <h1 className="admin-header-title">
              <Link
                to="/manageEmployee"
                className="admin-card-title-link custom-link"
              >
                <span className="fade-text">Manage Employee</span>
              </Link>
              {" > "}
              <span className="admin-card-title-span top-heading-add-employee">
                Edit Employee
              </span>
            </h1>
          </div>
        </div>
        {employeeData === null && (
          <div className="spinner-container">
            <TailSpin
              type="TailSpin"
              color="rgba(135, 106, 237, 1)"
              height={70}
              width={70}
              timeout={5000}
            />
          </div>
        )}
        {employeeData !== null && (
          <div className="card-addEmployee">
            <div className="card-body-addEmployee">
              <form
                onSubmit={formik.handleSubmit}
                className="form-container-addEmployee"
              >
                <div className="add-employee-left-section">
                  <div className="image-section">
                    <div className="employee-image-container">
                      {!imageUrl && ( // If imageUrl is not available
                        <div className="">
                          <img src={DefaultEmployeeProfile} alt="User Image" />
                        </div>
                      )}
                      {imageUrl && (
                        <div className="">
                          <img src={imageUrl} alt="Employee Image" />
                        </div>
                      )}
                      <div className="employee-image-container-inside-div">
                        <label htmlFor="imageUpload" className="fileLabel">
                          Choose Image
                        </label>
                        <input
                          id="imageUpload"
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group-addEmployee form-right-section">
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img className="email-icon" src={nameIcon} alt="icon" />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="text"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        placeholder=""
                        className={formik.values.name ? "filled" : ""}
                      />
                      <label htmlFor="employeeName">Employee Name</label>
                    </div>
                  </div>
                  {/* <div className="input-container-addEmployee input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={employeeIdIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="form-input-container">
                    <input
                      type="number"
                      min="0"
                      name="id"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.id}
                      placeholder="Enter Employee Id"
                    />
                  </div>
                </div> */}
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img className="email-icon" src={emailIcon} alt="icon" />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="email"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        placeholder=""
                        className={formik.values.email ? "filled" : ""}
                      />
                      <label htmlFor="emailAddress">Email Address</label>
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="number"
                        name="payRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.payRate}
                        placeholder=""
                        className={formik.values.payRate ? "filled" : ""}
                      />
                      <label htmlFor="payRate">Pay Rate ($/hr)</label>
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="number"
                        name="secondaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.secondaryPayRate}
                        placeholder=""
                        className={
                          shouldApplyFilledClass(formik.values.secondaryPayRate)
                            ? "filled"
                            : ""
                        }
                      />
                      <label htmlFor="secondaryPayRate">
                        Secondary Pay Rate ($/hr)
                      </label>
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={payrateIcon}
                        alt="icon"
                      />
                    </div>
                    <div className="form-input-container">
                      <input
                        type="number"
                        name="tertiaryPayRate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tertiaryPayRate}
                        placeholder=""
                        className={
                          shouldApplyFilledClass(formik.values.tertiaryPayRate)
                            ? "filled"
                            : ""
                        }
                      />
                      <label htmlFor="tertiaryPayRate">
                        Tertiary Pay Rate ($/hr)
                      </label>
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box">
                    <div className="generate-invoice-form-input-container select-type padding-select-type-left">
                      <Select
                        placeholder="Select Payment Method"
                        options={paymentOptions}
                        value={
                          formik.values.selectedPaymentMethod
                            ? {
                                value: formik.values.selectedPaymentMethod,
                                label: formik.values.selectedPaymentMethod,
                              }
                            : null
                        }
                        onChange={(option) => {
                          formik.setFieldValue(
                            "selectedPaymentMethod",
                            option?.value || "",
                          );
                        }}
                        isClearable
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "50vh",
                            overflowY: "scroll",
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            width: "30vw",
                            backgroundColor: "#ffff",
                            border: "none",
                            boxShadow: state.isFocused ? "none" : "none",
                            opacity: !(
                              formik.values.payFromDate &&
                              formik.values.payToDate
                            )
                              ? 0.5
                              : 1, // Optional: fade out when disabled
                            cursor: !(
                              formik.values.payFromDate &&
                              formik.values.payToDate
                            )
                              ? "not-allowed"
                              : "pointer",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            lineHeight: "21px",
                            fontWeight: 300,
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="input-container-addEmployee input-container-box input-container-box--employee-eligibility">
                    <div
                      style={{
                        display: "flex",
                        gap: "24px",
                        alignItems: "center",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontFamily: "Montserrat",
                        }}
                      >
                        <input
                          type="checkbox"
                          name="isPayslipEligible"
                          checked={!!formik.values.isPayslipEligible}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "isPayslipEligible",
                              e.target.checked,
                            )
                          }
                        />
                        Payslip Eligible
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontFamily: "Montserrat",
                        }}
                      >
                        <input
                          type="checkbox"
                          name="isInvoiceEligible"
                          checked={!!formik.values.isInvoiceEligible}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "isInvoiceEligible",
                              e.target.checked,
                            )
                          }
                        />
                        Invoice Eligible
                      </label>
                    </div>
                  </div>
                  {/* <div className="form-group-addEmployee form-right-section">
                  <label className="label-addEmployee">Image:</label>
                  <div className="employee-image-container">
                    <div className="input-container-addEmployee">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    </div>
                    {imageUrl && (
                      <div className="input-container-addEmployee">
                        <img src={imageUrl} alt="Employee Image" />
                      </div>
                    )}
                  </div>
                </div> */}
                  {loading && <LoaderForm />}{" "}
                  {/* Show loader if loading is true */}
                  {message && (
                    <div className="custom-modal">
                      <div className="modal-content">{message}</div>
                    </div>
                  )}
                  <div className="btn-addEmployee">
                    <button type="submit" className="add-employee-submit">
                      Update Info
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditEmployee;
